import { render, staticRenderFns } from "./saleDetails.vue?vue&type=template&id=5e953cf5&scoped=true&"
import script from "./saleDetails.vue?vue&type=script&lang=js&"
export * from "./saleDetails.vue?vue&type=script&lang=js&"
import style0 from "./saleDetails.vue?vue&type=style&index=0&id=5e953cf5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e953cf5",
  null
  
)

export default component.exports